import { render } from "./SongBehavior.vue?vue&type=template&id=43386f1d&scoped=true"
import script from "./SongBehavior.vue?vue&type=script&lang=js"
export * from "./SongBehavior.vue?vue&type=script&lang=js"

import "./SongBehavior.vue?vue&type=style&index=0&id=43386f1d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43386f1d"]])

export default __exports__